export class CookieUtils {
    static WriteCookie(name, value, activeUntil = null, subDomainsHaveAccess = false) {
        let expires = "";
        if (activeUntil) {
            let date = new Date(activeUntil);
            expires += "; expires=" + date.toUTCString();
        }
        if(subDomainsHaveAccess) {
            expires += "; domain=" + window.location.hostname;
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    static GetCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }

            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);

            }
        }
        return null;
    }

    static ClearCookie(name, subDomainsHaveAccess = false) {
        if(subDomainsHaveAccess) {
            document.cookie = name + '=; domain=' + window.location.hostname + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        } else {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    }
}
